import React from 'react';
import { Typography } from '@mui/material';
import { segmentsCriteriaLabels } from '@/lib/constants/hyperTrackerConstants';
import { SegmentId } from '@/lib/types/hypertrackerTypes';
import { Stack } from '@mui/system';

const AsideMenuSubItem = ({ group, onElementClick, t, onSegmentClick }) => {
    return (
        <Stack
            key={group.type}
            direction={'column'}
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            gap={'12px'}
            sx={{
                marginBottom: '12px',
                borderStyle: 'solid',
                borderColor: (theme) => theme.palette.divider,
                borderBottomWidth: '1px',
                padding: '12px 0',
            }}
        >
            {group.groupLabel && (
                <Typography variant={'p12'} color={'common.white'}>
                    {group.groupLabel}
                </Typography>
            )}
            {group.groupData.map((item) => {
                if (group.type === 'avatar') {
                    return (
                        <Typography
                            key={item.name}
                            sx={{ cursor: 'pointer' }}
                            variant="p12"
                            color="common.white"
                            onClick={() => {
                                onElementClick(item);
                            }}
                        >
                            {t(`profile_menu_drawer.${item.name}`)}
                        </Typography>
                    );
                }

                return (
                    <Typography
                        key={item.value}
                        sx={{
                            cursor: 'pointer',
                            '&:hover': {
                                backgroundColor: 'whiteTransparent',
                            },
                        }}
                        lineHeight={'32px'}
                        onClick={() => onSegmentClick(item.value)}
                    >
                        <Typography variant="p12" color="customText.text4">
                            {item.label}
                        </Typography>
                        &nbsp;
                        <Typography variant="p12" color="customText.text1">
                            {t(segmentsCriteriaLabels[item.value as SegmentId])}
                        </Typography>
                    </Typography>
                );
            })}
        </Stack>
    );
};

export default AsideMenuSubItem;
